import { FC } from 'react'
import cn from 'classnames'

import style from '@src/components/Title/Title.module.scss'

type TitleProps = {
  title: string,
  greenTitle: string,
  className?: string
}

export const Title: FC<TitleProps> = ({ className, title, greenTitle }) => (
  <div className={cn(style.header, className)}>
    <div>
      <span className={style.titleGreen}>{greenTitle}</span>
      {' '}
      {title}
    </div>
  </div>
)
